import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-navy-900 relative" data-id="element-201">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-800 via-navy-900 to-navy-900" data-id="element-202" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-navy-800 p-8 md:p-12 rounded-3xl border-2 border-gold-500 shadow-[0_0_50px_rgba(201,168,76,0.15)]" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-205">
            Tu Inversión Hoy
          </h2>

          <div className="space-y-4 mb-8" data-id="element-206">
            <p className="text-xl text-gray-400 line-through decoration-red-500/50 decoration-2" data-id="element-207">
              Precio normal en mi oficina de asesoría: $114.000 CLP
            </p>
            <p className="text-lg text-gray-300" data-id="element-208">
              Pero sé que si estás aquí, es porque el dinero te falta, no porque
              te sobre. Quiero que esto sea la última inversión que hagas antes
              de empezar a ahorrar de verdad.
            </p>
            <p className="text-xl font-medium text-white" data-id="element-209">
              Por eso, solo por hoy, puedes llevarte el protocolo completo por
              el precio de una pizza familiar:
            </p>
          </div>

          <div className="py-8 border-y border-navy-700 mb-8" data-id="element-210">
            <p className="text-sm text-gold-500 font-bold uppercase tracking-widest mb-2" data-id="element-211">
              Pago Único de
            </p>
            <div className="text-6xl md:text-7xl font-bold text-white flex justify-center items-start" data-id="element-212">
              <span className="text-3xl mt-2 mr-1" data-id="element-213">$</span>
              6,37
              <span className="text-2xl mt-8 ml-2 text-gray-400" data-id="element-214">usd</span>
            </div>
          </div>

          <CtaButton href="https://pequeguia.lat/cart/42329160548455:1" data-id="element-215" />

          <p className="mt-6 text-sm text-gray-400" data-id="element-216">
            * Oferta válida solo por el día de hoy. Acceso inmediato y de por
            vida al material digital.
          </p>
        </motion.div>
      </div>
    </section>;
}